import { RootState } from "../../store";

export const cleanStateSelector = (state: RootState) => state.clean;
